import { computed } from '@ember/object';
export default function getWithDefault(keyPath, def) {
  return computed(keyPath, function () {
    const value = this.get(keyPath);
    if (value === null || typeof value === 'undefined') {
      return def;
    }
    return value;
  });
}